// Display formatters — US format. Dates: MM/DD/YYYY. Months: MM/YYYY.
export function fmtDate(s) {
  if (!s) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s));
  if (!m) return s;
  return `${m[2]}/${m[3]}/${m[1]}`;
}

export function fmtMonth(s) {
  if (!s) return "";
  const m = /^(\d{4})-(\d{2})/.exec(String(s));
  if (!m) return s;
  return `${m[2]}/${m[1]}`;
}
